import { computed } from 'vue';

import { useQueryV2 } from '@libs/use';

import * as API from '../requests';

import { DepositReceiptAttachmentQuery } from '@libs/api-reference';
import { CASH_QUERY_KEYS } from '../constants';

export default function useGetReceiptAttachmentQuery(
  attachmentId: number | null
) {
  const {
    result,
    isPending: isLoadingAttachment,
    ...query
  } = useQueryV2<DepositReceiptAttachmentQuery>(
    () => API.getDepositReceiptAttachment(attachmentId),
    {
      key: CASH_QUERY_KEYS.receiptAttachment(attachmentId),
      staleTime: 1000 * 30,
    }
  );

  const attachment = computed(() => result.value?.data?.data);

  return { attachment, isLoadingAttachment, ...query };
}
